import { ValidatorFn, Validators } from '@angular/forms';
import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
export interface ExtensionConfig {
  fieldName: string;
  defaultValue: any;
  type?: 'formArray';
  validators?: Validators[] | ValidatorFn[];
  rulesConfig?: {
    entity: RuleEntity;
    entityParams: {
      required?: boolean;
      name: string;
      defaultValue: string;
    }[];
  }[];
}

export const VipProcessConfig: ExtensionConfig[] = [
  {
    fieldName: 'title',
    defaultValue: 'Priority processing',
    validators: [Validators.required],
  },
  {
    fieldName: 'description',
    defaultValue: 'Get special service for your order',
  },
  {
    fieldName: 'upsellRate',
    defaultValue: '6',
    validators: [Validators.required],
  },
  {
    fieldName: 'discount',
    defaultValue: '20',
  },
  {
    fieldName: 'prioritizeOrder',
    defaultValue: false,
  },
];

export interface VipProcessTemplate {
  title: string;
  description?: string;
  upsellRate: number | string;
  discount: number | string;
  prioritizeOrder?: boolean;
  attachTag?: boolean;
}
